import { Injectable } from "@angular/core";
import { MapperInterface } from "@app/shared/mapper/mapper-inteface";
import { MapperTipoIstanzaFascicolo } from "./mapper-tipo-istanza-fascicolo";
import { MapperClassifica } from "./mapper-classifica";
import { MapperRiferimentoFascicoloEsterno } from "./mapper-riferimento-fascicolo-esterno";
import { MapperTempiConservazione } from "./mapper-tempi-conservazione";
import { MapperDatiPersonali } from "./mapper-dati-personali";
import { MapperRiferimentoFascicoloCartaceo } from "./mapper-riferimento-fascicolo-cartaceo";
import { MapperCampoSpecificoFascicolo } from "./mapper-campo-specifico-fascicolo";
import { MapperIstanzaProcedimento } from "./mapper-istanza-procedimento";
import { MapperUtente } from "./mapper-utente";
import { FascicoloDTO } from "../dto/fascicoloDTO";
import { FascicoloVO } from "../vo/fascicoloVO";
import { MapperSettoreStruttura } from "./mapper-settore-struttura";
import { MapperRiferimentiPosizione } from "./mapper-riferimenti-posizione";
import { MapperUnitaDocumentaria } from "./mapper-unita-documentaria";
import { MapperVisibilitaFascicolo } from "./mapper-visibilita-fascicolo";
import { MapperCommento } from "./mapper-commento";
import { MapperLingua } from "./mapper-lingua";
import { MapperMetadatiRepertorio } from "./mapper-metadati-repertorio";
import { MapperSettore } from "./mapper-settore";
import { MapperIstanzaAttivita } from "./mapper-istanza-attivita";

@Injectable({
  providedIn: "root",
})
export class MapperFascicolo
  implements MapperInterface<FascicoloDTO, FascicoloVO> {
  constructor(
    private mapperTipoIstanzaFascicolo: MapperTipoIstanzaFascicolo,
    private mapperClassifica: MapperClassifica,
    private mapperStrutturaSettore: MapperSettoreStruttura,
    private mapperRiferimentoFascicoloEsterno: MapperRiferimentoFascicoloEsterno,
    private mapperTempiConservazione: MapperTempiConservazione,
    private mapperDatiPrivacy: MapperDatiPersonali,
    private mapperRiferimentoFascicoloCartaceo: MapperRiferimentoFascicoloCartaceo,
    private mapperCampoSpecificoFascicolo: MapperCampoSpecificoFascicolo,
    private mapperUtente: MapperUtente,
    private mapperUnitaDocumentaria: MapperUnitaDocumentaria,
    private mapperRiferimentiPosizione: MapperRiferimentiPosizione,
    private mapperAttivita: MapperIstanzaAttivita,
    private mapperMetadatiRepertorio: MapperMetadatiRepertorio,
    private mapperVisibilitaFascicolo: MapperVisibilitaFascicolo,
    private mapperCommento: MapperCommento,
    private mapperLingue: MapperLingua,
    private mapperSettore: MapperSettore
  ) { }

  convertVoToDto(vo: FascicoloVO): FascicoloDTO {
    if (vo != null) {
      const dto = new FascicoloDTO();
      dto.id = vo.id;
      dto.tipologia = this.mapperTipoIstanzaFascicolo.convertVoToDto(
        vo.tipologia
      );
      dto.oggetto = vo.oggetto;
      dto.descrizione = vo.descrizione;
      dto.documenti = this.mapperUnitaDocumentaria.convertListVoToDto(
        vo.documenti
      );
      dto.classifica = this.mapperClassifica.convertVoToDto(vo.classifica);
      dto.classificaAggiuntiva = this.mapperClassifica.convertVoToDto(vo.classificaAggiuntiva);
      dto.attivitaAssociata = this.mapperAttivita.convertVoToDto(
        vo.attivitaAssociata
      );

      dto.tempiConservazione = this.mapperTempiConservazione.convertVoToDto(
        vo.tempiConservazione
      );
      dto.datiPrivacy = this.mapperDatiPrivacy.convertVoToDto(vo.datiPersonali);
      dto.riferimentoFascicoloCartaceo = this.mapperRiferimentoFascicoloCartaceo.convertVoToDto(
        vo.riferimentoFascicoloCartaceo
      );
      dto.campiSpecifici = this.mapperCampoSpecificoFascicolo.convertListVoToDto(
        vo.campiSpecifici
      );

      dto.strutturaResponsabile = this.mapperStrutturaSettore.convertVoToDto(
        vo.strutturaResponsabile
      ); // modificare
      dto.riferimentoFascicoloEsterno = this.mapperRiferimentoFascicoloEsterno.convertVoToDto(
        vo.riferimentoFascicoloEsterno
      );
      dto.dataApertura = vo.dataApertura;
      dto.dataManuale = vo.dataManuale;
      dto.dataChiusura = vo.dataChiusura;
      dto.stato = vo.stato;
      dto.sottoFascicoli = this.convertListVoToDto(vo.sottoFascicoli);
      dto.riferimentoPosizione = this.mapperRiferimentiPosizione.convertVoToDto(
        vo.riferimentoPosizione
      );
      dto.visibilitaFascicolo = this.mapperVisibilitaFascicolo.convertListVoToDto(
        vo.visibilitaFascicolo
      );

      dto.lingue = this.mapperLingue.convertListVoToDto(vo.lingue);
      dto.dimensioni = vo.dimensioni;
      dto.dataUltimaModifica = vo.dataUltimaModifica;
      dto.estremoRecente = vo.estremoRecente;
      dto.estremoRemoto = vo.estremoRemoto;
      dto.altraDenominazione = vo.altraDenominazione;
      dto.contestoIstituzionale = vo.contestoIstituzionale;
      dto.repertoriato = vo.repertoriato;

      return dto;
    } else {
      return null;
    }
  }

  convertDtoToVo(dto: FascicoloDTO): FascicoloVO {
    if (dto != null) {
      const vo = new FascicoloVO();
      // TODO fare mapper questa riga funge solo se DTO e VO sono identici
      // vo = JSON.parse(JSON.stringify(dto));
      vo.id = dto.id;
      vo.tipologia = this.mapperTipoIstanzaFascicolo.convertDtoToVo(
        dto.tipologia
      );
      vo.oggetto = dto.oggetto;
      vo.descrizione = dto.descrizione;

      vo.documenti = this.mapperUnitaDocumentaria.convertListDtoToVo(
        dto.documenti
      );
      vo.classifica = this.mapperClassifica.convertDtoToVo(dto.classifica);
      vo.classificaAggiuntiva = this.mapperClassifica.convertDtoToVo(dto.classificaAggiuntiva);


      vo.segnaturaArchivistica = dto.segnaturaArchivistica;

      vo.attivitaAssociata = this.mapperAttivita.convertDtoToVo(
        dto.attivitaAssociata
      );

      vo.tempiConservazione = this.mapperTempiConservazione.convertDtoToVo(
        dto.tempiConservazione
      );
      vo.datiPersonali = this.mapperDatiPrivacy.convertDtoToVo(dto.datiPrivacy);
      vo.riferimentoFascicoloCartaceo = this.mapperRiferimentoFascicoloCartaceo.convertDtoToVo(
        dto.riferimentoFascicoloCartaceo
      );
      vo.campiSpecifici = this.mapperCampoSpecificoFascicolo.convertListDtoToVo(
        dto.campiSpecifici
      );

      vo.strutturaResponsabile = this.mapperStrutturaSettore.convertDtoToVo(
        dto.strutturaResponsabile
      );
      vo.riferimentoFascicoloEsterno = this.mapperRiferimentoFascicoloEsterno.convertDtoToVo(
        dto.riferimentoFascicoloEsterno
      );
      vo.dataApertura = dto.dataApertura;
      vo.dataAnnullamento = dto.dataAnnullamento;
      vo.dataChiusura = dto.dataChiusura;
      vo.dataManuale = dto.dataManuale;
      vo.dataVersione = dto.dataVersione;
      vo.creatoDa = this.mapperUtente.convertDtoToVo(dto.creatoDa);
      vo.stato = dto.stato;
      vo.sottoFascicoli = this.convertListDtoToVo(dto.sottoFascicoli);
      vo.riferimentoPosizione = this.mapperRiferimentiPosizione.convertDtoToVo(
        dto.riferimentoPosizione
      );

      vo.visibilitaFascicolo = this.mapperVisibilitaFascicolo.convertListDtoToVo(
        dto.visibilitaFascicolo
      );
      vo.commenti = this.mapperCommento.convertListDtoToVo(dto.commenti);
      vo.lingue = this.mapperLingue.convertListDtoToVo(dto.lingue);
      vo.dimensioni = dto.dimensioni;
      vo.dataUltimaModifica = dto.dataUltimaModifica;
      vo.estremoRemoto = dto.estremoRemoto;
      vo.estremoRecente = dto.estremoRecente;
      vo.altraDenominazione = dto.altraDenominazione;
      vo.contestoIstituzionale = dto.contestoIstituzionale;
      vo.documentazioneSeparata = dto.documentazioneSeparata;
      vo.metadatiRepertorio = this.mapperMetadatiRepertorio.convertDtoToVo(
        dto.metadatiRepertorio
      );
      vo.repertoriato = dto.repertoriato;
      vo.struttureAggiuntive = this.mapperSettore.convertListDtoToVo(
        dto.struttureAggiuntive
      );
      vo.modificatoDaLinneo = dto.modificatoDaLinneo;
      return vo;
    } else {
      return null;
    }
  }

  convertListVoToDto(voList: FascicoloVO[]): FascicoloDTO[] {
    if (voList != null) {
      return voList.map((vo) => this.convertVoToDto(vo));
    } else {
      return null;
    }
  }

  convertListDtoToVo(dtoList: FascicoloDTO[]): FascicoloVO[] {
    if (dtoList != null) {
      return dtoList.map((dto) => this.convertDtoToVo(dto));
    } else {
      return null;
    }
  }
}
